import React from "react";

const Dashboard = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center flex-column text-center"
      style={{ minHeight: "80vh" }}
    >
      <h1 className="text-primary fw-bold mb-4 display-5">
        📋 Document Reminder System
      </h1>

      <div className="bg-white shadow-lg rounded p-4 px-5">
        <p className="fs-5 text-dark mb-3">
          Welcome to your personalized dashboard! This system ensures that all
          your important documents are monitored for expiry.
        </p>
        <p className="fs-6 text-dark">
          📩 You will automatically receive <strong>SMS reminders</strong> for
          each document before it expires — no need to remember manually!
        </p>

        <ul className="list-group list-group-flush my-4 text-start">
          <li className="list-group-item">🔔 30 days before expiry</li>
          <li className="list-group-item">🔔 15 days before expiry</li>
          <li className="list-group-item">🔔 7 days before expiry</li>
          <li className="list-group-item">🔔 1 day before expiry</li>
        </ul>

        <p className="text-success fw-bold">
          Stay organized. Stay reminded. ⏳📱
        </p>
      </div>
    </div>
  );
};

export default Dashboard;
